import { DatePicker, Dropdown, Menu, Modal, Space } from "antd";
import { Complaints, Consultation, SupportDrawer, UiButton, UiCounterBatch, UiRangePicker, UiSearch, UiSelect, UiTable, UiTextArea } from "../../../components";
import { actionDropdownMenu, complaintAgainstDropdown, complaintesCustomerTabData, consultationTabData, CUSTOMER_COLUMS_HEADER, pendingConsultationDropdown } from "./config";
import React, { useEffect, useRef, useState } from "react";
import { lang_en_US as translation } from "../../../config";
import { useDispatch, useSelector } from "react-redux";
import { searchInitiateDelayTime, tablePageSizeOptions } from "../../../utils/appUtils";
import * as api from "../../../actions";
import { COMPLAINTS, CONSULTATION, CUSTOMERMANAGEMENT, LAWYERMANAGEMENT, SENDMESSAGEWHATSAPPSUPPORT, SENDMESSAGEMAILSUPPORT, SUPPORTMANAGEMENT } from "../../../apiServices/endpoints";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { loaderReducer } from "../../../reducer/loader.reducer";
import { actionDots, downloadReport, warningIcon } from "../../../assets/images";
import dayjs from "dayjs";
import CustomerView from "./customerProfileView";
import ConsultationView from "../../../components/consultation/consultationView";
import ComplaintView from "../../../components/consultation/complaintView";
import ConsultationReport from "../../../components/consultation/consultationReport";
import { showErrorNotification, showSuccessNotification } from "../../../components/uiNotification";
import { useReactToPrint } from "react-to-print";
import AllCustomerReport from "./report";
import { messageTabData } from "../../../components/complaints/config";

const PrintAllCustomerReport = React.forwardRef((props, ref) => {
    return <div ref={ref}>
        <AllCustomerReport data={props?.data} fromDate={props?.fromDate} toDate={props?.toDate} selectedMonth={props?.selectedMonth} selectedMonthString={props?.selectedMonthString} />
    </div>
});

const PrintConsultationReport = React.forwardRef((props, ref) => {
    return <div ref={ref}>
        <ConsultationReport data={props?.data} activeTab={props?.activeTab} allConsultationData={props?.allConsultationData} consultation={props?.consultation} />
    </div>
});

const Customer = () => {
    const keywords = translation?.customer;
    const dispatch = useDispatch();
    const debounceTimeOut = useRef(null);
    const queryClient = useQueryClient();
    const reportRef = useRef(null);
    const consultationRef = useRef(null);
    const adminuserId = sessionStorage.getItem("userId");
    const configResults = useSelector((state) => state.configAction.configData);
    const minutesConfig = configResults?.find((detail) => detail?.configId === "MINUTES")?.configuration?.map((config) => ({ key: config, value: `${config} Min` }));
    const activeStatus = configResults?.find((detail) => detail?.configId === "USER STATUS")?.configuration?.map((config) => ({ key: config, value: config }));
    const blockDaysOption = configResults?.find((detail) => detail?.configId === "BLOCKING_DAYS")?.configuration?.map((config) => ({ key: config, value: `${config} Days` }));
    const agreementConfig = configResults?.find((detail) => detail?.configId === "clientuseragreement");
    const agreementMd = agreementConfig?.configuration?.[0] || agreementConfig?.defaultValue || "";


    const handlePrintCustomerReport = useReactToPrint({
        content: () => reportRef.current,
        onAfterPrint: () => setCustomerFilter(prev => ({ ...prev, isReportOpen: false, size: 10 })),
        pageStyle: `body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                }
                 .customer-report::before {
                    content: "";
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    border: 2px solid #005D60;
                    z-index: 9999;
                    pointer-events: none;
                }`
    });

    const [customerFilter, setCustomerFilter] = useState({
        page: 0, size: 10, month: null, monthString: "", fromDate: "", toDate: "", searchFilter: "", searchTermValue: "", userStatus: "ACTIVE", blockDays: "", reason: "", isReportOpen: false
    });
    const [customerOpenCloseAction, setCustomerOpenCloseAction] = useState({
        isOpenProfileDrawer: false, openInactiveModel: false
    });
    const [actionsMenu, setActionsMenu] = useState(actionDropdownMenu);
    const [customerData, setCustomerData] = useState([]);
    const [customerByIdDate, setCustomerByIdData] = useState({ customerProfile: "", data: {} });
    const [consultation, setConsultation] = useState({
        activeTab: "COMPLETED",
        activeTabKey: "1",
        page: 0,
        size: 10,
        customerId: "",
        openConsultation: false,
        fromDate: "",
        toDate: "",
        month: null,
        monthString: "",
        searchFilter: "",
        searchTermValue: "",
        profile: "",
        getconsultation: false,
        consultationTime: "",
        isCustomer: false
    });
    const [consultationBooleans, setConsultationBooleans] = useState({
        isconsultationDrawerOpen: false,
        isComplaintDrawerOpen: false,
        isConsultationReportOpen: false,
        isSendMessage: false,
        isSendWarningMessage: false,
        isComplaintReportOpen: false,
        isSupportDrawerOpen: false
    });
    const [consultationData, setConsultationData] = useState([]);
    const [consultationIdData, setConsultationIdData] = useState({ lawyerProfile: "", customerProfile: "", consultationInfo: {} });
    const [complaintsFilter, setComplaintFilters] = useState({
        activeTab: "COMPLAINT_RAISED_LAWYER",
        activeTabKey: "1",
        fromDate: "",
        toDate: "",
        page: 0,
        size: 10,
        month: "",
        monthString: "",
        searchFilter: "",
        searchTermValue: "",
        complaintStatus: "PENDING",
        customerId: "",
        getComplaint: false,
        menuType: "",
        isComplaintReportOpen: false, isAllComplaintReportOpen: false, isCustomer: false,
        supportId: ""
    });
    const [complaintIdData, setComplaintIDData] = useState({ rasiedByProfile: "", againstByProfile: "", data: {} });
    const [supportIdData, setSupportIdData] = useState({ profileUrl: "", data: {} });
    const [complaintsResponseData, setComplaintsResponseData] = useState({ lawyerResponse: {}, customerResponse: {}, lawyerProfile: "", complaintsData: [] });
    const [messageData, setMessageData] = useState({
        againstById: "",
        raisedById: "",
        body: "",
        subject: "",
        complaintType: "",
        warning: false,
        activeTab: "raised",
        complaintId: "",
        warnedBy: "",
        activeTabKey: "1",
        isWhatsapp: false,
        isMail: true,
        isButtonEnable: false
    });
    const [supportMessage, setSupportMessage] = useState({
        platforms: ["whatsapp"],
        subject: "",
        message: ""
    });

    const getAllCustomer = (page, size, status, searchTermValue, monthString, fromDate, toDate) => api.get(`${CUSTOMERMANAGEMENT}/page?page=${page}&size=${size}${status ? `&userStatus=${status}` : ""}${fromDate && toDate ? `&startDate=${fromDate}&endDate=${toDate}` : ""}${monthString ? `&month=${monthString}` : ''}${searchTermValue ? `&commonSearch=${searchTermValue}` : ""}`);
    const getCustomerById = (id) => api.get(`${CUSTOMERMANAGEMENT}/${id}`);
    const getCustomerConsultation = (id, size, page, activeTab, fromDate, toDate, searchTermValue, monthString, consultationTime) => api.get(`${CONSULTATION}/cumulative_consultation?size=${size}&page=${page}&customerId=${id}${activeTab ? `&consultationStatus=${activeTab}` : ""}${fromDate && toDate ? `&stateDate=${fromDate}&endDate=${toDate}` : ""}${searchTermValue ? `&commanSearch=${searchTermValue}` : ""}${monthString ? `&month=${monthString}` : ""}${consultationTime ? `&consultationTime=${consultationTime}` : ""}`);
    const getConsultationById = (id) => api.get(`${CONSULTATION}/${id}`);
    const getCustomerComplaints = (id, page, size, status, activeTab, monthString, fromDate, toDate, searchTermValue) => {
        if (activeTab === "support") {
            return api.get(`${SUPPORTMANAGEMENT}/get_support?page=${page}&size=${size}&customerId=${id}&complaintType=COMPLAINT_RAISED_CUSTOMER${status ? `&complaintStatus=${status}` : ""}${monthString ? `&month=${monthString}` : ""}${fromDate && toDate ? `&fromDate=${fromDate}&toDate=${toDate}` : ""}${searchTermValue ? `&commonSearch=${searchTermValue}` : ""}`);
        }
        return api.get(`${COMPLAINTS}/get_complaints?page=${page}&size=${size}&customerId=${id}${activeTab !== "support" ? `&complaintType=${activeTab}` : ""}${status ? `&complaintStatus=${status}` : ""}${monthString ? `&month=${monthString}` : ""}${fromDate && toDate ? `&fromDate=${fromDate}&toDate=${toDate}` : ""}${activeTab === "support" ? `&isSupport=${true}` : ""}${searchTermValue ? `&commonSearch=${searchTermValue}` : ""}`);
    };
    const getComplaintById = (id) => api.get(`${COMPLAINTS}/${id}`);
    const getSupportById = (id) => api.get(`${SUPPORTMANAGEMENT}/${id}`);
    const sendWhatsAppMessage = (payload) => api.post(SENDMESSAGEWHATSAPPSUPPORT, payload);
    const sendMailMessage = (payload) => api.post(SENDMESSAGEMAILSUPPORT, payload);
    const holdCustomer = (id, payload) => api.post(`${CUSTOMERMANAGEMENT}/hold_customer/${id}`, payload);
    const activeCustomer = (id) => api.post(`${CUSTOMERMANAGEMENT}/active_customer/${id}`);

    const { data: allCustomerData, refetch: fetchCustomers, isFetching: isFetchingAllCustomer } = useQuery(["FETCH_ALL_CUSTOMER", customerFilter?.page, customerFilter?.size, customerFilter?.userStatus, customerFilter?.searchTermValue, customerFilter?.monthString, customerFilter?.fromDate, customerFilter?.toDate,], () => getAllCustomer(customerFilter?.page, customerFilter?.size, customerFilter?.userStatus, customerFilter?.searchTermValue, customerFilter?.monthString, customerFilter?.fromDate, customerFilter?.toDate), {
        onSuccess: (customerResponse) => {
            if (customerResponse?.statusCode === 200) {
                setCustomerData(customerResponse?.result?.customerResponse?.content);
            }
        },
        enabled: Boolean(customerFilter?.page || customerFilter?.size || customerFilter?.userStatus || customerFilter?.monthString || customerFilter?.fromDate || customerFilter?.toDate || customerFilter?.searchTermValue),
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingCustomerById } = useQuery(["FETCH_CUSTOMER_BY_ID", ""], getCustomerById, {
        onSuccess: (customerIdResponse) => {
            setCustomerOpenCloseAction(prev => ({ ...prev, isOpenProfileDrawer: true }));
            setCustomerByIdData(prev => ({ ...prev, customerProfile: `${CUSTOMERMANAGEMENT}/file${customerIdResponse?.result?.customerResponse?.profileUrl}`, data: customerIdResponse?.result?.customerResponse }));
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { data: allConsultationData, isFetching: isFetchingCustomerConsultationById } =
        useQuery(["FETCH_CUSTOMER_CONSULTATION_BY_ID", consultation?.customerId, consultation?.size, consultation?.page, consultation?.activeTab, consultation?.fromDate, consultation?.toDate, consultation?.searchTermValue, consultation?.monthString, consultation?.consultationTime],
            () => getCustomerConsultation(consultation?.customerId, consultation?.size, consultation?.page, consultation?.activeTab, consultation?.fromDate, consultation?.toDate, consultation?.searchTermValue, consultation?.monthString, consultation?.consultationTime), {
            onSuccess: (consultationResponse) => {
                if (consultationResponse?.statusCode === 200) {
                    setConsultation(prev => ({ ...prev, openConsultation: true, profile: `${CUSTOMERMANAGEMENT}/file${consultationResponse?.result?.consultationCumulativeResponse?.lawyerResponse?.profileUrl}` }));
                    setConsultationData(consultationResponse?.result?.consultationCumulativeResponse?.consultationResponsePage?.content);
                }
                else {
                    setConsultation(prev => ({ ...prev, getconsultation: false }));
                    showErrorNotification("Error");
                }
            },
            enabled: consultation?.getconsultation && Boolean(consultation?.customerId || consultation?.activeTab || consultation?.page || consultation?.size || consultation?.fromDate || consultation?.toDate || consultation?.searchTermValue || consultation?.monthString || consultation?.consultationTime),
            refetchOnWindowFocus: false
        });

    const { isFetching: isFetchingConsultationById } = useQuery(["FETCH_CONSULTATION_BY_ID", ""], getConsultationById, {
        onSuccess: (consultationIdResponse) => {
            if (consultationIdResponse?.statusCode === 200) {
                setConsultationBooleans(prev => ({ ...prev, isconsultationDrawerOpen: true }));
                setConsultationIdData(prev => ({
                    ...prev,
                    lawyerProfile: `${LAWYERMANAGEMENT}/file${consultationIdResponse?.result?.consultationResponse?.lawyerResponse?.profileUrl}`,
                    customerProfile: `${CUSTOMERMANAGEMENT}/file${consultationIdResponse?.result?.consultationResponse?.customerResponse?.profileUrl}`,
                    consultationInfo: consultationIdResponse?.result?.consultationResponse
                }));
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingComplaintById } = useQuery(["FETCH_COMPLAINT_BY_ID", ""], getComplaintById, {
        onSuccess: (complaintResponse) => {
            if (complaintResponse?.statusCode === 200) {
                if (complaintsFilter?.menuType === "report") {
                    setComplaintFilters(prev => ({ ...prev, isComplaintReportOpen: true }));
                    setConsultationBooleans(prev => ({ ...prev, isComplaintDrawerOpen: false }));
                }
                else {
                    setComplaintFilters(prev => ({ ...prev, isComplaintReportOpen: false }));
                    setConsultationBooleans(prev => ({ ...prev, isComplaintDrawerOpen: true }));
                }
                const isCustomerRaised = complaintIdData?.complaintType === "COMPLAINT_RAISED_CUSTOMER";
                setComplaintIDData(prev => ({ ...prev, rasiedByProfile: `${isCustomerRaised ? CUSTOMERMANAGEMENT : LAWYERMANAGEMENT}file/${complaintResponse?.result?.complaintResponse?.raisedByProfileUrl}`, againstByProfile: `${isCustomerRaised ? CUSTOMERMANAGEMENT : LAWYERMANAGEMENT}/file${complaintResponse?.result?.complaintResponse?.againstByProfileUrl}`, data: complaintResponse?.result?.complaintResponse }));
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingSupportById } = useQuery(["FETCH_SUPPORT_BY_ID", complaintsFilter?.supportId], () => getSupportById(complaintsFilter?.supportId), {
        onSuccess: (supportResponse) => {
            if (supportResponse?.statusCode === 200) {
                setConsultationBooleans(prev => ({ ...prev, isSupportDrawerOpen: true }));
                const data = supportResponse?.result?.supportResponse;
                setSupportIdData(prev => ({
                    ...prev,
                    profileUrl: `${CUSTOMERMANAGEMENT}/file${data?.raisedByProfileUrl}`,
                    data: data
                }));
                let platforms = ['whatsapp'];
                if (data?.complaintStatus === 'COMPLETED' && data?.supportedIn) {
                    platforms = [];
                    if (data?.supportedIn?.includes('WHATSAPP')) {
                        platforms.push('whatsapp');
                    }
                    if (data?.supportedIn?.includes('EMAIL')) {
                        platforms.push('email');
                    }
                }
                setSupportMessage(prev => ({ ...prev, platforms: platforms, message: data?.actionItem || '', subject: data?.subjectActionItem || '' }));
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { data: allComplaints, refetch: fetchComplaints, isFetching: isFetchingCustomerComplaints } = useQuery(["FETCH_CUSTOMER_COMPLAINTS", complaintsFilter?.customerId, complaintsFilter?.page, complaintsFilter?.size, complaintsFilter?.complaintStatus, complaintsFilter?.activeTab, complaintsFilter?.monthString, complaintsFilter?.fromDate, complaintsFilter?.toDate, complaintsFilter?.searchTermValue, customerFilter?.getComplaint], () => getCustomerComplaints(complaintsFilter?.customerId, complaintsFilter?.page, complaintsFilter?.size, complaintsFilter?.complaintStatus, complaintsFilter?.activeTab, complaintsFilter?.monthString, complaintsFilter?.fromDate, complaintsFilter?.toDate, complaintsFilter?.searchTermValue), {
        onSuccess: (complaintResponse) => {
            if (complaintResponse?.statusCode === 200) {
                setComplaintFilters(prev => ({ ...prev, openComplaints: true }));
                const result = complaintResponse?.result;
                const details = result?.lawyerComplaintDetails || result?.supportDetailsResponse;
                const pageData = details?.complaintResponsePage || details?.supportResponsePage;
                setComplaintsResponseData(prev => ({
                    ...prev, lawyerResponse: details?.lawyerResponse,
                    customerResponse: details?.customerResponse,
                    complaintsData: pageData?.content,
                    lawyerProfile: `${CUSTOMERMANAGEMENT}/file${details?.lawyerResponse?.profileUrl}`
                }));
            }
            else {
                setComplaintFilters(prev => ({ ...prev, getComplaint: false }));
                showErrorNotification("Error", complaintResponse?.response?.data?.error?.message);
            }
        },
        enabled: complaintsFilter?.getComplaint && Boolean(complaintsFilter?.customerId || complaintsFilter?.page || complaintsFilter?.size || complaintsFilter?.complaintStatus || complaintsFilter?.activeTab || complaintsFilter?.monthString || complaintsFilter?.fromDate || complaintsFilter?.toDate || complaintsFilter?.searchTermValue),
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingSendMessage } = useQuery(["SEND_MESSAGE_WHATSAPP", ""], sendWhatsAppMessage, {
        onSuccess: (sendResponse) => {
            if (sendResponse?.data?.statusCode === 200) {
                handleSendMessageClose();
                setConsultationBooleans(prev => ({ ...prev, isSendMessage: false, isSendWarningMessage: false, isSupportDrawerOpen: false }));
                setMessageData(prev => ({ ...prev, activeTab: "raised", activeTabKey: "1", isMail: true, isWhatsapp: false, body: "", subject: "" }));
                setSupportMessage({ platforms: ["whatsapp"], subject: "", message: "" });
                showSuccessNotification("Success", sendResponse?.data?.result?.response);
                fetchComplaints();
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingSenfMailMessage } = useQuery(["SEND_MESSAGE_MAIL", ""], sendMailMessage, {
        onSuccess: (mailResponse) => {
            if (mailResponse?.data?.statusCode === 200) {
                setConsultationBooleans(prev => ({ ...prev, isSendMessage: false, isSendWarningMessage: false, isSupportDrawerOpen: false }));
                setMessageData(prev => ({ ...prev, activeTab: "raised", activeTabKey: "1", isMail: true, isWhatsapp: false, body: "", subject: "" }));
                setSupportMessage({ platforms: ["whatsapp"], subject: "", message: "" });
                showSuccessNotification("Success", mailResponse?.data?.result?.response);
                fetchComplaints();
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingHoldCustomer } = useQuery(["HOLD_CUSTOMER", ""], holdCustomer, {
        onSuccess: (holdresponse) => {
            if (holdresponse?.data?.statusCode === 200) {
                setCustomerOpenCloseAction(prev => ({ ...prev, openInactiveModel: false }));
                showSuccessNotification("Success", holdresponse?.data?.result?.response);
                fetchCustomers();
                setCustomerFilter(prev => ({ ...prev, reason: "", blockDays: "" }));
            }
            else{
                showErrorNotification("Error", holdresponse?.response?.data?.error?.message || "Could not hold the customer. Please try again later.");
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingActiveCustomer } = useQuery(["ACTIVATE_CUSTOMER", ""], activeCustomer, {
        onSuccess: (activeresponse) => {
            if (activeresponse?.data?.statusCode === 200) {
                setCustomerOpenCloseAction(prev => ({ ...prev, openInactiveModel: false }));
                showSuccessNotification("Success", activeresponse?.data?.result?.response);
                fetchCustomers();
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const handlePagination = (page, size, type) => {
        if (type === "customer") {
            setCustomerFilter(prev => ({ ...prev, page: page - 1, size: size }));
        }
    };

    const selectedMinute = minutesConfig?.find(option => Number(option?.key) === Number(consultation?.consultationTime));

    const handleDateChange = (date, type) => {
        const fromDate = dayjs(date?.[0]).format("YYYY-MM-DD");
        const toDate = dayjs(date?.[1]).format("YYYY-MM-DD");
        if (date) {
            if (fromDate && toDate) {
                if (type === "customer") {
                    setCustomerFilter(prev => ({ ...prev, fromDate: fromDate, toDate: toDate, month: null, monthString: "" }));
                }
                else if (type === "complaints") {
                    setComplaintFilters(prev => ({ ...prev, fromDate: fromDate, toDate: toDate, month: null, monthString: "" }));
                }
                else if (type === "consultation") {
                    setConsultation(prev => ({ ...prev, prev, fromDate: fromDate, toDate: toDate, month: null, monthString: "" }));
                }
            }
        }
        else {
            if (type === "customer") {
                setCustomerFilter(prev => ({ ...prev, fromDate: "", toDate: "" }));
            }
            else if (type === "complaints") {
                setComplaintFilters(prev => ({ ...prev, fromDate: "", toDate: "" }));
            }
            else if (type === "consultation") {
                setConsultation(prev => ({ ...prev, prev, fromDate: "", toDate: "" }));
            }
        }
    };

    const handleMonthChange = (month, type) => {
        const monthValue = dayjs(month).format("YYYY-MM");
        if (type === "customer") {
            if (month) {
                setCustomerFilter(prev => ({ ...prev, month: month, monthString: monthValue, fromDate: "", toDate: "" }));
            }
            else {
                setCustomerFilter(prev => ({ ...prev, month: null, monthString: "" }));
            }
        }
        else if (type === "consultation") {
            if (month) {
                setConsultation(prev => ({ ...prev, month: month, monthString: monthValue, fromDate: "", toDate: "" }));
            }
            else {
                setConsultation(prev => ({ ...prev, month: null, monthString: "" }));
            }
        }
        else if (type === "complaints") {
            if (month) {
                setComplaintFilters(prev => ({ ...prev, month: month, monthString: monthValue, fromDate: "", toDate: "" }));
            }
            else {
                setComplaintFilters(prev => ({ ...prev, month: null, monthString: "" }));
            }
        }
    };

    const handleSearch = (searchValue, type) => {
        const searchTerm = searchValue;
        if (type === "customer") {
            setCustomerFilter(prev => ({ ...prev, searchFilter: searchTerm }));
        }
        else if (type === "consultation") {
            setConsultation(prev => ({ ...prev, searchFilter: searchTerm }));
        }
        else if (type === "complaints") {
            setComplaintFilters(prev => ({ ...prev, searchFilter: searchTerm }));
        }
        debounceSearch(searchTerm, type);
    };

    const debounceSearch = (searchTerm, type) => {
        if (debounceTimeOut?.current) {
            clearTimeout(debounceTimeOut?.current);
        }
        if (searchTerm !== "") {
            debounceTimeOut.current = setTimeout(() => {
                if (type === "customer") {
                    setCustomerFilter(prev => ({ ...prev, searchTermValue: searchTerm, page: 0, size: 10 }));
                }
                else if (type === "consultation") {
                    setConsultation(prev => ({ ...prev, searchTermValue: searchTerm, pageSize: { ...prev?.pageSize, page: 0, size: 10 }, }));
                }
                else if (type === "complaints") {
                    setComplaintFilters(prev => ({ ...prev, searchTermValue: searchTerm, page: 0, size: 10 }));
                }
            }, searchInitiateDelayTime);
        }
        else {
            if (type === "customer") {
                setCustomerFilter(prev => ({ ...prev, searchTermValue: "", page: 0, size: 10 }));
            }
            else if (type === "consultation") {
                setConsultation(prev => ({ ...prev, searchTermValue: "", page: 0, size: 10 }));
            }
            else if (type === "complaints") {
                setComplaintFilters(prev => ({ ...prev, searchTermValue: "", page: 0, size: 10 }));
            }
        }
    };

    const handleActiveInactiveFilter = (selectedValue,) => {
        setCustomerFilter(prev => ({ ...prev, userStatus: selectedValue }));
        let updatedMenu = actionDropdownMenu;
        if (selectedValue === "ACTIVE") {
            updatedMenu = actionDropdownMenu?.map(item =>
                item.key === "hold"
                    ? { ...item, key: "hold", label: "Hold" }
                    : item
            );
        }
        if (selectedValue === "INACTIVE" || selectedValue === "HOLD") {
            updatedMenu = actionDropdownMenu?.map(item =>
                item.key === "hold"
                    ? { ...item, key: "active", label: "Active" }
                    : item
            );
        }
        setActionsMenu(updatedMenu);
    };

    const getConsultationDropdown = (details) => {
        const lawyerComplaint = details?.lawyerComplaintDto && Object.keys(details?.lawyerComplaintDto)?.length > 0;
        const customerComplaint = details?.customerComplaintDto && Object.keys(details?.customerComplaintDto)?.length > 0;
        if (lawyerComplaint && customerComplaint) {
            return [
                { key: "view", label: "View" },
                { key: "viewLawyerRasiedComplaints", label: "View Advocate Rasied Complaint" },
                { key: "viewCustiomerRasiedComplaint", label: "View Customer Rasied Complaint" },
            ];
        }
        else if (lawyerComplaint || customerComplaint) {
            return [
                { key: "view", label: "View" },
                { key: "viewComplaint", label: "View Complaints" },
            ];
        }
        else {
            return [
                { key: "view", label: "View" },
            ];
        }
    };

    const handleConsultationAction = (menuType, list) => {
        if (menuType === "view") {
            queryClient.prefetchQuery(["FETCH_CONSULTATION_BY_ID", ""], () => getConsultationById(list?.consultationId));
        }
        else if (menuType === "viewComplaint") {
            let complaintId = null;
            if (list?.lawyerComplaintDto && Object.keys(list?.lawyerComplaintDto)?.length > 0) {
                complaintId = list.lawyerComplaintDto?.complaintId;
            }
            if (list?.customerComplaintDto && Object.keys(list?.customerComplaintDto)?.length > 0) {
                complaintId = list?.customerComplaintDto?.complaintId;
            }
            queryClient.prefetchQuery(["FETCH_COMPLAINT_BY_ID", ""], () => getComplaintById(complaintId));
        }
        else if (menuType === "viewLawyerRasiedComplaints") {
            queryClient.prefetchQuery(["FETCH_COMPLAINT_BY_ID", ""], () => getComplaintById(list?.lawyerComplaintDto?.complaintId));
        }
        else if (menuType === "viewCustiomerRasiedComplaint") {
            queryClient.prefetchQuery(["FETCH_COMPLAINT_BY_ID", ""], () => getComplaintById(list?.customerComplaintDto?.complaintId));
        }
    };

    const handleAction = (menuType, list) => {
        if (menuType === "view") {
            queryClient.prefetchQuery(["FETCH_CUSTOMER_BY_ID", ""], () => getCustomerById(list?.customerId));
        }
        else if (menuType === "inactive" || menuType === "active" || menuType === "hold") {
            setCustomerOpenCloseAction(prev => ({ ...prev, openInactiveModel: true }));
            setCustomerFilter(prev => ({ ...prev, customerId: list?.customerId }));
        }
        else if (menuType === "complaints") {
            setComplaintFilters(prev => ({ ...prev, customerId: list?.customerId, getComplaint: true, isCustomer: true }));
        }
        else if (menuType === "consultation") {
            setConsultation(prev => ({ ...prev, customerId: list?.customerId, getconsultation: true, isCustomer: true }));
        }
    };

    const menuList = (menuItems, list) => {
        return <Menu>
            {
                menuItems?.map((menuDetails) => {
                    return <Menu.Item key={menuDetails?.key}
                        onClick={(event) => {
                            event?.domEvent?.stopPropagation();
                            handleAction(menuDetails?.key, list);
                        }}
                    >{menuDetails?.label}</Menu.Item>
                })
            }
        </Menu>
    };

    const consultMenuList = (menuItems, list) => {
        return <Menu>
            {
                menuItems?.map((menuDetails) => {
                    return <Menu.Item key={menuDetails?.key} onClick={(event) => {
                        event?.domEvent?.stopPropagation();
                        handleConsultationAction(menuDetails?.key, list);
                    }}>
                        {menuDetails?.label}
                    </Menu.Item>
                })
            }
        </Menu>
    };

    const consultationActionRender = (list, filteredList) => {
        return <div style={{ textAlign: "center" }} onClick={(event) => event?.stopPropagation()}>
            <Dropdown overlay={(consultMenuList(consultation?.activeTab === "COMPLETED" || consultation?.activeTab === "CANCELLED" ? filteredList : pendingConsultationDropdown, list))} trigger={["click"]}>
                <Space onClick={(event) => {
                    event?.preventDefault();
                    event?.stopPropagation();
                }} style={{ justifyContent: "center", width: "100%", cursor: "pointer" }}>
                    <img src={actionDots} alt="ActionDots" />
                </Space>
            </Dropdown>
        </div>
    };

    const actionRender = (list) => {
        return <div style={{ textAlign: "center" }} onClick={(event) => event?.stopPropagation()}>
            <Dropdown overlay={menuList(actionsMenu, list)} trigger={["click"]}>
                <Space onClick={(event) => {
                    event?.preventDefault();
                    event?.stopPropagation();
                }} style={{ justifyContent: "center", width: "100%", cursor: "pointer" }}>
                    <img src={actionDots} alt="Action Dots" />
                </Space>
            </Dropdown>
        </div>
    };

    const complantMenuList = (menuItems, list) => {
        return <Menu>
            {
                menuItems?.map((menuDetails) => {
                    return <Menu.Item key={menuDetails?.key} onClick={(event) => {
                        event?.domEvent?.stopPropagation();
                        handleComplaintAction(menuDetails?.key, list);
                    }}>
                        {menuDetails?.label}
                    </Menu.Item>
                })
            }
        </Menu>
    };

    const complaintActionRender = (list) => {
        return <div style={{ textAlign: "center" }} onClick={(event) => event?.stopPropagation()}>
            <Dropdown overlay={(complantMenuList(complaintAgainstDropdown, list))} trigger={["click"]}>
                <Space onClick={(event) => {
                    event?.preventDefault();
                    event?.stopPropagation();
                }} style={{ justifyContent: "center", width: "100%", cursor: "pointer" }}>
                    <img src={actionDots} alt="ActionDots" />
                </Space>
            </Dropdown>
        </div>
    };

    const handleCustomerRowClick = (customerDetail) => {
        handleAction("view", customerDetail);
    };

    const handleCustomerProfileClose = () => {
        setCustomerOpenCloseAction(prev => ({ ...prev, isOpenProfileDrawer: false }));
    };

    const handleConsultationCancel = () => {
        setConsultation(prev => ({ ...prev, getconsultation: false, activeTab: "COMPLETED", openConsultation: false, activeTabKey: "1", page: 0, size: 10, monthString: "", month: null, fromDate: "", toDate: "", searchTermValue: "" }));
        fetchCustomers();
    };

    const handleConsultationTabChange = (key) => {
        consultationTabData?.forEach((tab) => {
            if (tab?.key === key) {
                const { content } = tab || {};
                setConsultation(prev => ({ ...prev, activeTab: content, page: 0, size: 10, searchFilter: "", searchTermValue: "", month: null, monthString: "", fromDate: "", toDate: "", consultationTime: "" }));
            }
        });
        setConsultation(prev => ({ ...prev, activeTabKey: key, page: 0, size: 10 }));
    };

    const handleMinuteChages = (minute) => {
        if (minute) {
            setConsultation(prev => ({ ...prev, consultationTime: Number(minute) }));
        }
        else {
            setConsultation(prev => ({ ...prev, consultationTime: "" }));
        }
    };

    const handleConsultationClose = () => {
        setConsultationBooleans(prev => ({ ...prev, isconsultationDrawerOpen: false }));
    };

    const handleConsultationReport = () => {
        setConsultation(prev => ({ ...prev, size: -1 }));
        setConsultationBooleans(prev => ({ ...prev, isConsultationReportOpen: true }));
    };

    const handleMessageChange = (fieldValue, fieldName) => {
        setMessageData(prev => ({ ...prev, [fieldName]: fieldValue }));
    };

    const handleMessageTabChange = (key) => {
        messageTabData?.forEach((tab) => {
            if (tab?.key === key) {
                const { content } = tab || {};
                setMessageData(prev => ({ ...prev, activeTab: content }));
            }
            setMessageData(prev => ({ ...prev, activeTabKey: key }));
            setMessageData(prev => ({ ...prev, body: "", subject: "", isWhatsapp: false, isMail: true }));
        });
    };

    const handlComplaintsDetailClose = () => {
        setConsultationBooleans(prev => ({ ...prev, isComplaintDrawerOpen: false }));
    };

    const handleSendMessage = (messageType, list) => {
        setConsultationBooleans(prev => ({ ...prev, isSendMessage: messageType === "sendMessage", isSendWarningMessage: messageType === "sendWarningMessage" }));
        setMessageData(prev => ({
            ...prev, complaintType: list?.data?.complaintType,
            warning: messageType === "sendWarningMessage",
            againstById: list?.data?.againstById,
            raisedById: list?.data?.raisedById,
            complaintId: list?.data?.complaintId,
            warnedBy: adminuserId,
        }));
    };

    const handleMessageCheck = (check, type) => {
        if (type === "whatsapp") {
            setMessageData(prev => ({ ...prev, isWhatsapp: check }));
        }
        else if (type === "mail") {
            setMessageData(prev => ({ ...prev, isMail: check }));
        }
        else if (type === "warning") {
            setMessageData(prev => ({ ...prev, warning: check }));
        }
    };

    const handleSendMessageClose = () => {
        setConsultationBooleans(prev => ({ ...prev, isSendMessage: false, isSendWarningMessage: false }));
        setMessageData(prev => ({ ...prev, activeTab: "raised", activeTabKey: "1", isMail: true, isWhatsapp: false, body: "", subject: "" }));
    };

    const handleSubmitMessage = () => {
        const basePayload = {
            ...(messageData?.activeTab === "against" ? { againstById: messageData?.againstById } : {}),
            ...(messageData?.activeTab === "raised" ? { raisedById: messageData?.raisedById } : {}),
            complaintType: messageData?.complaintType,
            subject: messageData?.subject,
            body: messageData?.body,
            warning: messageData?.warning,
            complaintId: messageData?.complaintId,
            warnedBy: messageData?.warnedBy
        }
        if (messageData?.isWhatsapp && messageData?.isMail) {
            const warnedInArray = ["WHATSAPP", "EMAIL"];
            queryClient.prefetchQuery(["SEND_MESSAGE_WHATSAPP", ""], () => sendWhatsAppMessage({ ...basePayload, warnedIn: warnedInArray }));
            queryClient.prefetchQuery(["SEND_MESSAGE_MAIL", ""], () => sendMailMessage({ ...basePayload, warnedIn: warnedInArray }));
        }
        else if (messageData?.isWhatsapp) {
            queryClient.prefetchQuery(["SEND_MESSAGE_WHATSAPP", ""], () => sendWhatsAppMessage({ ...basePayload, warnedIn: ["WHATSAPP"] }));
        }
        else if (messageData?.isMail) {
            queryClient.prefetchQuery(["SEND_MESSAGE_MAIL", ""], () => sendMailMessage({ ...basePayload, warnedIn: ["EMAIL"] }));
        }
    };

    const handleSupportSendMessage = () => {
        const selectedPlatforms = supportMessage?.platforms || [];
        const basePayload = {
            body: supportMessage?.message,
            supportId: supportIdData?.data?.supportId || "",
            complaintType: supportIdData?.data?.complaintType || "",
            userId: supportIdData?.data?.userId || "",
            subject: supportMessage?.subject,
            actionItemTakenById: adminuserId
        }
        if (selectedPlatforms?.includes("whatsapp")) {
            queryClient.prefetchQuery(["SEND_MESSAGE_WHATSAPP", ""], () => sendWhatsAppMessage({ ...basePayload, supportedIn: 'WHATSAPP' }));
        }
        if (selectedPlatforms?.includes("email")) {
            queryClient.prefetchQuery(["SEND_MESSAGE_MAIL", ""], () => sendMailMessage({ ...basePayload, supportedIn: 'EMAIL' }));
        }
    };

    const handleComplaintAction = (menuType, list) => {
        if (menuType === "view") {
            if (complaintsFilter?.activeTab === "support") {
                setComplaintFilters(prev => ({ ...prev, supportId: list?.supportId }));
                queryClient.prefetchQuery(["FETCH_SUPPORT_BY_ID", list?.supportId], () => getSupportById(list?.supportId));
            } else {
                setComplaintFilters(prev => ({ ...prev, menuType: "view" }));
                setConsultationBooleans(prev => ({ ...prev, isDownloadButtonEnable: false }));
                queryClient.prefetchQuery(["FETCH_COMPLAINT_BY_ID", ""], () => getComplaintById(list?.complaintId));
            }
        }
    };

    const handleComplaintTabChange = (key) => {
        complaintesCustomerTabData?.forEach((tab) => {
            if (tab?.key === key) {
                const { content } = tab || {};
                setComplaintFilters(prev => ({ ...prev, activeTab: content, page: 0, size: 10, month: null, monthString: "", searchFilter: "", searchTermValue: "", fromDate: "", toDate: "", complaintStatus: "PENDING" }));
            }
        })
        setComplaintFilters(prev => ({ ...prev, activeTabKey: key, page: 0, size: 10 }));
    };

    const handleComplaintsCancel = () => {
        setComplaintFilters(prev => ({ ...prev, getComplaint: false, openComplaints: false, activeTab: "COMPLAINT_RAISED_CUSTOMER", activeTabKey: "1", page: 0, size: 10, monthString: "", month: null, fromDate: "", toDate: "", searchTermValue: "", menuType: "", complaintStatus: "PENDING" }));
        fetchCustomers();
    };

    const handleComplaintStatus = (status) => {
        if (status) {
            setComplaintFilters(prev => ({ ...prev, complaintStatus: status }));
        }
        else {
            setComplaintFilters(prev => ({ ...prev, complaintStatus: "" }));
        }
    };

    const handleActiveClose = () => {
        setCustomerOpenCloseAction(prev => ({ ...prev, openInactiveModel: false }));
        setCustomerFilter(prev => ({ ...prev, reason: "", blockDays: "" }));
    };

    const handleActiveChange = (fieldValue, fieldName) => {
        setCustomerFilter(prev => ({ ...prev, [fieldName]: fieldValue }));
    };

    const handleActivationSubmit = (type) => {
        const isHoldDetailsValid = Boolean(customerFilter?.blockDays && customerFilter?.reason?.trim());
        const payload = {
            reason: customerFilter?.reason?.trim(),
            blockDays: Number(customerFilter?.blockDays),
            blockDate: dayjs().format('YYYY-MM-DD')
        }
        if (type === "active") {
            queryClient.prefetchQuery(["ACTIVATE_CUSTOMER", ""], () => activeCustomer(customerFilter?.customerId));
        }
        else if (type === "hold") {
            if (!isHoldDetailsValid) {
                showErrorNotification("Error", "Block days and reason are required");
                return;
            }
            queryClient.prefetchQuery(["HOLD_CUSTOMER", ""], () => holdCustomer(customerFilter?.customerId, payload));
        }
    };

    const handleReportPrint = () => {
        setCustomerFilter(prev => ({ ...prev, size: -1, isReportOpen: true }));
    };

    useEffect(() => {
        if (customerFilter?.isReportOpen) {
            handlePrintCustomerReport();
        }
    }, [customerFilter?.isReportOpen, handlePrintCustomerReport]);

    useEffect(() => {
        const isMail = messageData?.isMail ?? true;
        const isButtonEnable = Boolean(messageData?.subject && messageData?.body && (messageData?.isWhatsapp || isMail));
        if (messageData?.isButtonEnable !== isButtonEnable) {
            setMessageData(prev => ({ ...prev, isButtonEnable: isButtonEnable }));
        }
    }, [messageData?.subject, messageData?.body, messageData?.isButtonEnable, messageData?.isWhatsapp, messageData?.isMail]);

    useEffect(() => {
        const isLoading = isFetchingAllCustomer || isFetchingCustomerById || isFetchingCustomerConsultationById || isFetchingConsultationById || isFetchingComplaintById || isFetchingCustomerComplaints || isFetchingSendMessage || isFetchingSenfMailMessage || isFetchingHoldCustomer || isFetchingActiveCustomer || isFetchingSupportById;
        dispatch(loaderReducer(isLoading));
    }, [dispatch, isFetchingAllCustomer, isFetchingCustomerById, isFetchingCustomerConsultationById, isFetchingConsultationById, isFetchingComplaintById, isFetchingCustomerComplaints, isFetchingSendMessage, isFetchingSenfMailMessage, isFetchingHoldCustomer, isFetchingActiveCustomer, isFetchingSupportById]);

    const totalCustomerCount = allCustomerData?.result?.customerResponse?.totalElements || 0;
    const shouldShowCustomerPagination = totalCustomerCount > 10;
    const isActivateAction = customerFilter?.userStatus === "INACTIVE" || customerFilter?.userStatus === "HOLD";
    const isHoldDetailsValid = Boolean(customerFilter?.blockDays && customerFilter?.reason?.trim());

    return <>
        {
            (!complaintsFilter?.openComplaints && !consultation?.openConsultation) && <div>
                <div className="flexible">
                    <div className="flexible">
                        <h6 style={{ padding: "8px 0px", margin: 0 }}>Customer Management</h6>
                        <UiCounterBatch>{allCustomerData?.result?.customerResponse?.totalElements}</UiCounterBatch>
                    </div>
                    <div className="flexible">
                        <UiSelect allowClear={false} value={customerFilter?.userStatus} options={activeStatus} onChange={(status) => handleActiveInactiveFilter(status)} />
                        <DatePicker value={customerFilter?.month || null} picker="month" format="MMM" style={{ height: "32px" }} onChange={(month) => handleMonthChange(month, "customer")} />
                        <UiRangePicker value={customerFilter?.fromDate && customerFilter?.toDate ? [dayjs(customerFilter?.fromDate), dayjs(customerFilter?.toDate)] : null} onChange={(date) => handleDateChange(date, "customer")} disabledDate={(current) => current && current > dayjs().endOf("day")} />
                        <UiSearch onChange={(search) => handleSearch(search.target.value, "customer")} placeholder={keywords?.searchPlaceHolder} />
                        <UiButton type="primary" onClick={handleReportPrint}> <img src={downloadReport} alt="" />Download Report</UiButton>
                    </div>
                </div>
                <div>
                    <UiTable columns={CUSTOMER_COLUMS_HEADER({ actionRender, userStatus: customerFilter?.userStatus })}
                        dataSource={customerData}
                        onRow={(customerDetail) => ({
                            onClick: () => handleCustomerRowClick(customerDetail)
                        })}
                        scroll={{ y: "calc(100vh - 250px)" }}
                        pagination={customerFilter?.isReportOpen || !shouldShowCustomerPagination ? false : {
                            pageSize: customerFilter?.size || 10,
                            current: customerFilter?.page + 1,
                            total: totalCustomerCount,
                            pageSizeOptions: tablePageSizeOptions,
                            showSizeChanger: true,
                            onChange: (page, size) => handlePagination(page, size, "customer")
                        }} />
                </div>
                {
                    customerOpenCloseAction?.isOpenProfileDrawer && <CustomerView
                        customerOpenCloseAction={customerOpenCloseAction}
                        handleCustomerProfileClose={handleCustomerProfileClose}
                        customerByIdDate={customerByIdDate}
                        userStatus={customerFilter?.userStatus}
                        agreementMd={agreementMd}
                    />
                }
                <Modal
                    closable={false}
                    open={customerOpenCloseAction?.openInactiveModel}
                    footer={<div className="flexible-end">
                        <UiButton onClick={handleActiveClose}>No</UiButton>
                        <UiButton disabled={!isActivateAction && !isHoldDetailsValid} onClick={() => handleActivationSubmit(isActivateAction ? "active" : "hold")} style={{ backgroundColor: "#F1C40F", color: "#fff" }}>Yes</UiButton>
                    </div>}
                >
                    {
                        isActivateAction ? <div>
                            <div className="inactive-model">
                                <img src={warningIcon} alt="" />
                                <p>Are you sure you want to make this Customer Active ?</p>
                            </div>
                        </div> : <div>
                            <div className="inactive-model">
                                <img src={warningIcon} alt="" />
                                <p>Are you sure you want to Hold this Customer ?</p>
                            </div>
                            <div>
                                <label style={{ padding: "0px 10px", marginBottom: "10px" }}>No of days to Block <span style={{ color: "red" }}>*</span></label>
                                <UiSelect value={customerFilter?.blockDays || undefined} style={{ width: "100%", padding: "0px 10px" }} options={blockDaysOption} required name="blockDays" onChange={(days) => handleActiveChange(days, "blockDays")} placeholder={"Select Days"} />
                                <UiTextArea value={customerFilter?.reason} label={"Reason"} required name="reason" onChange={(field) => handleActiveChange(field?.target?.value, "reason")} placeholder={"Reason..."} />
                            </div>
                        </div>
                    }
                </Modal>
            </div>
        }
        {
            complaintsFilter?.openComplaints && (<Complaints
                handleDateChange={handleDateChange}
                handlePagination={handlePagination}
                complaintActionRender={complaintActionRender}
                handleComplaintTabChange={handleComplaintTabChange}
                complaintsFilter={complaintsFilter}
                handleComplaintsCancel={handleComplaintsCancel}
                handleSearch={handleSearch}
                handleMonthChange={handleMonthChange}
                handleComplaintStatus={handleComplaintStatus}
                complaintsResponseData={complaintsResponseData}
                handleComplaintAction={handleComplaintAction}
                allComplaints={allComplaints}
            />)}
        {
            consultation?.openConsultation && (<Consultation
                handleDateChange={handleDateChange}
                handlePagination={handlePagination}
                handleConsultationCancel={handleConsultationCancel}
                handleConsultationTabChange={handleConsultationTabChange}
                consultationData={consultationData}
                allConsultationData={allConsultationData}
                consultation={consultation}
                consultationRef={consultationRef}
                consultationActionRender={consultationActionRender}
                handleSearch={handleSearch}
                handleMonthChange={handleMonthChange}
                handleConsultationReport={handleConsultationReport}
                setConsultation={setConsultation}
                setConsultationBooleans={setConsultationBooleans}
                getConsultationDropdown={getConsultationDropdown}
                minutesConfig={minutesConfig}
                selectedMinute={selectedMinute}
                handleMinuteChages={handleMinuteChages} />)}
        {
            consultationBooleans?.isconsultationDrawerOpen && <ConsultationView
                consultation={consultation}
                consultationBooleans={consultationBooleans}
                consultationIdData={consultationIdData}
                handleConsultationClose={handleConsultationClose} />}
        {
            consultationBooleans?.isComplaintDrawerOpen && <ComplaintView
                consultationBooleans={consultationBooleans}
                handlComplaintsDetailClose={handlComplaintsDetailClose}
                handleSendMessage={handleSendMessage}
                handleSendMessageClose={handleSendMessageClose}
                complaintIdData={complaintIdData}
                setComplaintFilters={setComplaintFilters}
                handleMessageChange={handleMessageChange}
                handleMessageTabChange={handleMessageTabChange}
                messageData={messageData}
                handleMessageCheck={handleMessageCheck}
                handleSubmitMessage={handleSubmitMessage}
                complaintsFilter={complaintsFilter}
                isFetchingSendMessage={isFetchingSendMessage}
            />}
        {
            consultationBooleans?.isSupportDrawerOpen && <SupportDrawer
                openProfileView={consultationBooleans?.isSupportDrawerOpen}
                handleProfileCancel={() => setConsultationBooleans(prev => ({ ...prev, isSupportDrawerOpen: false }))}
                supportProfileData={{
                    ...supportIdData?.data,
                    name: supportIdData?.data?.raisedByName,
                    mobileNumber: supportIdData?.data?.raisedByMobileNumber,
                    email: supportIdData?.data?.raisedByEmail,
                    profilePic: supportIdData?.profileUrl
                }}
                activeTab={"CUSTOMERS"}
                selectedPlatforms={supportMessage?.platforms}
                setSelectedPlatforms={(val) => setSupportMessage(prev => ({ ...prev, platforms: val }))}
                subject={supportMessage?.subject}
                setSubject={(val) => setSupportMessage(prev => ({ ...prev, subject: val }))}
                message={supportMessage?.message}
                setMessage={(val) => setSupportMessage(prev => ({ ...prev, message: val }))}
                handleSendMessage={handleSupportSendMessage}
            />
        }
        <div style={{ display: "none" }}>
            <PrintAllCustomerReport ref={reportRef} data={customerData} fromDate={customerFilter?.fromDate} toDate={customerFilter?.toDate} selectedMonth={customerFilter?.month} selectedMonthString={customerFilter?.monthString} />
            <PrintConsultationReport ref={consultationRef} data={consultationData} activeTab={consultation?.activeTab} allConsultationData={allConsultationData} consultation={consultation} />
        </div>
    </>
};
export default Customer